import type { FaireProductEntity } from "../../entity_types/product";

export const p_p7hx8ftsr7: FaireProductEntity = {
  token: "p_p7hx8ftsr7",
  type: "product",
  name: "Instant - Single Origin Decaf Pack",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl: "https://cdn.faire.com/fastly/d809e7a29d2ec96e1671fd06b8e7f87ce896fd70682900e5c87dcbf015caefec.jpeg",
  galleryImageUrls: [],
  priceDollars: 14,
  description: "Just add hot water and you can make some delicious decaf coffee while traveling, on the go, or even at home!\n\npack of 6 decaf packets in a lovely box\n\nYou're don't need to compromise flavor to have coffee on the go -- even decaf!!  \nThis decaf instant coffee is made from our perfectly roasted decaf beans and processed by Swift Coffee to ensure a wonderful and delicious cup every time.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:07.586Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
